import classnames from "classnames";
import React, { InputHTMLAttributes, useState } from "react";
import style from "../../scss/export.module.scss";
import CheckIcon from "../Icons/CheckIcon";
import "./checkbox.scss";

export interface TCheckbox extends InputHTMLAttributes<HTMLInputElement> {
    label?: string | JSX.Element;
    loading?: boolean | null;
    checkboxClassName?: string;
    onDarkBackground?: boolean;
    buttonStyle?: boolean;
    customColorsReversed?: boolean;
    isValid?: boolean;
}

export const Checkbox = ({
    label,
    loading,
    checkboxClassName,
    onDarkBackground = false,
    buttonStyle = false,
    customColorsReversed = false,
    isValid,
    ...inputProps
}: TCheckbox) => {
    const [internalChecked, setInternalChecked] = useState(inputProps.defaultChecked || false);
    const isControlled = inputProps.checked !== undefined;
    const currentChecked = isControlled ? inputProps.checked : internalChecked;

    const className = classnames("c-checkbox", checkboxClassName, {
        "c-checkbox--on-dark-bg": onDarkBackground,
        "c-checkbox--disabled": inputProps.disabled,
        "c-checkbox--loading": loading,
        "c-checkbox--button-style-checked-checkbox": buttonStyle && currentChecked,
        "c-checkbox--button-style-unchecked-checkbox": buttonStyle && !currentChecked,
        "c-checkbox--custom-colors-reversed": customColorsReversed,
        "c-checkbox--error": isValid === false,
    });
    const inputClassName = classnames("c-checkbox__checkbox");
    const iconClassName = classnames("c-checkbox__icon", {
        "c-checkbox__icon-button-style-checkbox": buttonStyle,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isControlled) {
            setInternalChecked(e.target.checked);
        }
        inputProps.onChange?.(e);
    };

    return (
        <label className={className}>
            <span>{label}</span>
            <input type="checkbox" className={inputClassName} onChange={handleChange} {...inputProps} />
            <span className={iconClassName} aria-hidden={true}>
                {currentChecked && <CheckIcon color={style.whiteColor} />}
            </span>
        </label>
    );
};
